import React from 'react'
import { Button, ButtonProps } from 'src/antd'

import { DownOutlined, AntdIconProps } from 'src/icons/antd-compat'

export type TDropdownSimpleTogglerProps = {
  iconProps?: AntdIconProps & { ref?: React.MutableRefObject<HTMLSpanElement> }
  Icon?: typeof DownOutlined
} & Omit<ButtonProps, 'title'>

const DropdownSimpleToggler = ({
  iconProps = {},
  Icon = DownOutlined,
  ...buttonProps
}: TDropdownSimpleTogglerProps) => {
  return (
    <Button {...buttonProps}>
      {buttonProps?.children} <Icon {...iconProps} />
    </Button>
  )
}

export default DropdownSimpleToggler
